import React from 'react'
import { Link } from "react-router-dom";


const ENT = () => {
    return (
        <>
            <section className="page-title" style={{ backgroundImage: 'url(assets/images/background/3.jpg)' }}>
                <div className="auto-container">
                    <h2>नाक, कान, गला रोग विभाग</h2>
                    <ul className="bread-crumb clearfix">
                        <li><Link to="/">Home</Link></li>
                        <li style={{ color: "green" }}>नाक, कान, गला रोग विभाग</li>
                    </ul>
                </div>
            </section>

            <div className="sidebar-page-container left-sidebar" style={{ marginTop: "-100px" }}>
                <div className="auto-container">
                    <marquee width="100%" direction="left" height="" ><br />
                        <b className='' style={{ fontSize: "18px", color: "green" }}>अन्य सुविधा - ECG | USG | X-Ray | ICU | Ventilator । फामेसर्सी । पैथालॉली</b>
                    </marquee>
                    <div className="row clearfix">
                        <div className="sidebar-side col-lg-4 col-md-12 col-sm-12">
                            <aside className="sidebar sticky-top">
                                <div className="sidebar-widget department-widget">
                                    <div className="widget-content">
                                        <ul className="department-list">
                                            <li className="active"><Link to="/ent">नाक, कान, गला रोग विभाग</Link></li>
                                            <li className=""><Link to="/orthopedic">Orthopedic</Link></li>
                                            <li ><Link to="/neurosurgery">Neurosurgery</Link></li>
                                            <li ><Link to="/neurology">Neurology</Link></li>
                                            <li ><Link to="/gynaecology">Gynaecology</Link></li>
                                            <li><Link to="/general-surgery">General Surgery</Link></li>
                                            <li><Link to="/general-medicine">General Medicine</Link></li>
                                            <li ><Link to="/gastroenterology">Gastroenterology</Link></li>
                                            <li><Link to="/paediatrics">Paediatrics</Link></li>
                                            <li ><Link to="/neuropsychiatrist">Neuropsychiatrist</Link></li>

                                        </ul>
                                    </div>
                                </div>
                                {/* Time Widget */}
                                {/* <div className="sidebar-widget time-widget">
                  <div className="widget-content">
                    <div className="time-widget_content">
                      <span className="clock_icon flaticon-clock" />
                      <h4>Working Time</h4>
                      <ul className="working-time_list">
                        <li>Mon-Thu <span>08:00 - 20:00</span></li>
                        <li>Friday <span>07:00 - 22:00</span></li>
                        <li>Saturday <span>08:00 - 18:00</span></li>
                      </ul>
                    </div>
                  </div>
                </div> */}
                                {/* Time Widget */}
                                <div className="sidebar-widget contact-info_widget">
                                    <div className="widget-content">
                                        <div className="time-widget_content">
                                            <h4>Contact Info</h4>
                                            <ul className="contact-info_widget-list">
                                                <li><span className="icon fa-solid fa-phone fa-fw" /><Link style={{ color: "black" }} to='https://share.google/fCIHbcmFHPs4QBm5t' target="_blank">सतना स्वास्तिक हॉस्पिटल पन्नीलाल चौक, सतना (म.प्र.)</Link></li>
                                                <li><span className="icon fa-solid fa-envelope fa-fw" /> <Link style={{ color: "black" }} to="mailto:satnaswastikhospital@gmail.com">satnaswastikhospital@gmail.com</Link></li>
                                                {/* <li><span className="icon fa-solid fa-clock fa-fw" />Mon - Sat 8:00 - 6:30, <br /> Sunday - CLOSED</li> */}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                {/* Expert Widget */}
                                <div className="sidebar-widget expert_widget" style={{ backgroundImage: 'url(assets/images/background/pattern-33.png)' }}>
                                    <span className="color-layer" />
                                    <h3>Experienced Team of Doctors, Nurses, and Staff</h3>
                                    <Link to="/appointment" className="theme-btn btn-style-one">
                                        <span className="btn-wrap">
                                            <span className="text-one">Book Appointment</span>
                                            <span className="text-two">Book Appointment</span>
                                        </span>
                                    </Link>
                                    <div className="image">
                                        <img src="assets/images/resource/doctor-1.png" alt />
                                    </div>
                                </div>
                            </aside>
                        </div>
                        {/* Content Side */}
                        <div className="content-side col-lg-8 col-md-12 col-sm-12">
                            <div className="department-detail">
                                <div className="inner-box">
                                    <div className="image">
                                        <img src="https://res.cloudinary.com/dnquglkeh/image/upload/v1772992060/%E0%A4%A8%E0%A4%BE%E0%A4%95_tglyp7.jpg" alt />
                                    </div>
                                    <h3>नाक, कान, गला रोग विभाग</h3>
                                    <p> नाक, कान और गला रोग विभाग (ENT) अस्पताल का एक महत्वपूर्ण विभाग है, जहाँ नाक, कान, गले और सिर-गर्दन से संबंधित बीमारियों का विशेषज्ञ डॉक्टरों द्वारा जांच और उपचार किया जाता है। इस विभाग में आधुनिक उपकरणों और उन्नत तकनीकों की सहायता से मरीजों को सही निदान और प्रभावी इलाज प्रदान किया जाता है।

                                        हमारे ENT विभाग में कान में दर्द, सुनने में कमी, कान से पानी आना, साइनस की समस्या, नाक बंद होना, एलर्जी, गले में दर्द, टॉन्सिल, आवाज बैठना, और निगलने में कठिनाई जैसी समस्याओं का इलाज किया जाता है। इसके अलावा नाक, कान और गले से जुड़ी छोटी-बड़ी सर्जरी भी अनुभवी विशेषज्ञों द्वारा सुरक्षित तरीके से की जाती है।

                                        हमारा उद्देश्य मरीजों को बेहतर स्वास्थ्य सेवाएँ प्रदान करना, सही समय पर सही उपचार देना और उनकी जीवन गुणवत्ता को बेहतर बनाना है। यहाँ हर मरीज की समस्या को ध्यान से समझकर व्यक्तिगत उपचार योजना बनाई जाती है।</p>

                                    <h3>Conditions we treat</h3>
                                    <div className="graph-outer">
                                        <div className="row clearfix">
                                            <div className="column col-lg-6 col-md-6 col-sm-12">
                                                <ul className="list">
                                                    <li className=''> कान से पानी एवं मवाद आना</li>
                                                    <li> बहरेपन का इलाज</li>
                                                    <li> कान का पर्दा फटना</li>
                                                    <li> कान में आवाजें आना (Tinnitus) </li>
                                                    <li> चक्कर आने का इलाज (Vertigo)</li>
                                                    <li> एंडोस्कोपी</li>
                                                    <li> मायरिंगोप्लास्ट</li>
                                                    <li> टिम्पेनोप्लास्टी</li>
                                                    <li> मास्टोइडेक्टॉमी</li>
                                                    <li> सेप्टोप्लास्टी</li>
                                                    <li> फ्रैक्चर नेज़ल बोन रिडक्शन</li>
                                                    <li> एंडोस्कोपिक साइनस सर्जरी</li>
                                                    <li>  सर्दी, खांसी, जुकाम (Sinusitis)</li>
                                                    <li>  बंद नाक व सर दर्द</li>
                                                    <li> नाक से सांस न आना </li>
                                                </ul>
                                            </div>
                                            <div className="column col-lg-6 col-md-6 col-sm-12">
                                                <ul className="list">
                                                    <li className='mt-lg-4'> मुँह के घाव</li>
                                                    <li>  बढ़े हुए टॉन्सिल का इलाज एवं ऑपरेशन</li>
                                                    <li> गले में अटकना</li>
                                                    <li> गले की गांठें होना</li>
                                                    <li> गले व मुँह का कैंसर</li>
                                                    <li> थायरॉइड</li>
                                                    <li> गले में जलन</li>
                                                    <li> आवाज का बदलना</li>
                                                    <li> स्कार/केलोइड सर्जरी</li>
                                                    <li>पैरोटिडेक्टॉमी</li>
                                                    <li> हेमीथायरॉइडेक्टॉमी</li>
                                                    <li> ट्रैकियोस्टॉमी</li>
                                                    <li className=''> छींकें आना, एलर्जी का इलाज (Allergy)</li>
                                                    <li> नाक व मुँह से खून आना </li>

                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <h3>Specialists</h3>
                                    <div className=" col-lg-6 col-md-12 col-sm-12">
                                        <div className="inner-box wow fadeInLeft animated" data-wow-delay="450ms" data-wow-duration="1500ms" style={{ visibility: 'visible', animationDuration: '1500ms', animationDelay: '450ms', animationName: 'fadeInLeft' }}>
                                            <div className="image">
                                                <img src="assets/img/Dr. Shruti Shandilya.webp" alt style={{ width: "200px", height: "200px", borderRadius: "100px" }} />
                                            </div>
                                            <div className="lower-content">
                                                <div className="content">
                                                    <h5 style={{ textAlign: "justify", marginTop: "-22px" }}><a to="#" style={{ textAlign: "center" }}>Dr. Shruti Shandilya</a></h5>
                                                    <div className="designation" style={{ textAlign: "" }}>MBBS, MS (ENT)</div>


                                                </div>
                                                {/* <a to="#" className="plus-box flaticon-plus" /> */}
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="image">
                    <img src="assets/img/Dr. Divyant Gupta.webp" alt style={{width:"200px", height:"200px", borderRadius:"100px"}} />
                  </div>
                  <p><strong>Electrocardiogram (ECG or EKG): </strong>this records the electrical activity of the heart.</p> */}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>




        </>
    )
}

export default ENT